import { render } from "./HowMuchScreen.vue?vue&type=template&id=33f081c0"
import script from "./HowMuchScreen.vue?vue&type=script&lang=js"
export * from "./HowMuchScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__